import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import { ButtonFontSize, ButtonSize, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button/button';
import classes from './comment-pre-built-limited-cart-success.scss';
export const CommentPreBuiltLimitedCartSuccessPopupComponent = ({
  open,
  onClose
}) => {
  const renderContent = () => /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.description
  }, "Thanks so much for the feedback. We will take a look shortly and get back to you soon."), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    textTransform: ButtonTextTransform.none,
    fontSize: ButtonFontSize.small,
    type: ButtonType.primary,
    size: ButtonSize.large,
    className: classes.button,
    onClick: onClose
  }, "Close")));
  return /*#__PURE__*/React.createElement(PopupDialog, {
    title: "Your message has been successfully sent",
    dataPopup: "CommentPreBuiltLimitedCartSuccessPopup",
    titleClasses: classes.header,
    titleHeader: classes.header,
    content: renderContent(),
    contentClass: classes.content,
    popupClassName: classes.popup,
    showCloseButton: true,
    open: open,
    onClose: onClose
  });
};